/*
  Animation for Statistics Block.
 */
function easeOut(x, power) {
    return 1 - Math.pow(1 - x, power);
}

function animateNumber(el, start, end, duration) {
    // Handle decimals.
    let decimals = 0;
    if (Math.floor(end) !== end) {
        decimals = end.toString().split(".")[1].length;
    }

    let startTimestamp = null;
    const step = (timestamp) => {
        if (!startTimestamp) {
            startTimestamp = timestamp;
        }
        const progress = Math.min(
            easeOut((timestamp - startTimestamp) / duration, 5),
            1,
        );

        const currentValue = progress * (end - start) + start;

        // Round to decimals, or to integer.
        el.innerHTML = decimals
            ? currentValue.toFixed(decimals)
            : Math.floor(currentValue).toLocaleString();

        if (progress < 1) {
            window.requestAnimationFrame(step);
        }
    };
    window.requestAnimationFrame(step);
}

window.easeOut = easeOut;
window.animateNumber = animateNumber;
